/**
 * File search-result. Treating this as a block because it is only loaded on the search page
 */
import getAjaxContent from '../utils/get-ajax-content.js';

import updateFilters from '../utils/update-filters';

(() => {
	/**
	 * SearchResults class
	 */
	class SearchResults {
		constructor(sector) {
			const rootEl = sector;
			const transition = 100;
			let settings = {};

			const filters = rootEl.querySelectorAll(
				'ul.search-section__filters li'
			);
			//Remove previous filters and pagination
			const URL = window.location.href.split('&')[0];

			const _loadMoreButton = rootEl.querySelector(
				'div.load-more-button-width-display-number__button'
			);

			const _insert = rootEl.querySelector('span.search-section__insert');
			//Settings used within fetch body
			if (
				_loadMoreButton instanceof window.HTMLElement &&
				_insert instanceof window.HTMLElement
			) {
				settings = {
					action: 'search_results',
					// eslint-disable-next-line no-undef
					query: searchMyAjax, // Search query
					paged: 1, // Which page of results to return
					// eslint-disable-next-line no-undef
					maxPage: searchMaxPageMyAjax, // Total number of page results
					// eslint-disable-next-line no-undef
					nonce: ajax_params.ajaxNonce,
					insert: _insert, // Where to inset the new content into the DOM
					// eslint-disable-next-line no-undef
					button: _loadMoreButton,
					rootEl,
					transition,
				};
				//Button click event
				_loadMoreButton.addEventListener('click', () => {
					settings.paged++;
					getAjaxContent(settings);
				});
			}

			filters.forEach((el) => {
				el.addEventListener('click', function () {
					//Updates the state of the filters
					updateFilters(el, 'search-section__filters__item--active');
					//redirect
					window.location.href =
						URL + '&filter=' + el.getAttribute('data-type');
				});
			});
		}
	}

	class Handler {
		constructor(sector, sectorClass) {
			this.sector = sector;
			this.sectorClass = sectorClass;
			new SearchResults(this.sector);
		}
	}

	// Init a handler for each block instance
	const sectorClass = 'search-section';
	const sectors = Array.from(
		document.querySelectorAll(`section.${sectorClass}`)
	);
	sectors.forEach((o) => new Handler(o, sectorClass));
})();
